const triggerHtml5FormValidation = require("../form/triggerHtml5FormValidation");
const openWhitepaper2024FormLoading = require("./openWhitepaper2024FormLoading");
const disableSubmitButtonInForm = require("../form/disableSubmitButtonInForm");
const getFormDataAsWhitepaper2024FormData = require("./getFormDataAsWhitepaper2024FormData");
const convertWhitepaper2024FormDataToGoogleSheetsFormData = require("./convertWhitepaper2024FormDataToGoogleSheetsFormData");
const submitFormToGoogleSheets = require(".././googleSheet/submitFormToGoogleSheets");
const sendWhitepaper2024FormSubmissionStartedEmailToFormsAtIterableCom = require("./sendWhitepaper2024FormSubmissionStartedEmailToFormsAtIterableCom");
const identifyInHeap = require("../heap/identifyInHeap");
const saveReturningUserData = require(".././returningUser/saveReturningUserData");
const shouldBlockEmailDomainSilently = require("./shouldBlockEmailDomainSilently");
const submitFormToMarketo = require("../marketo/submitFormToMarketo");
const openSuccess = require("./openSuccess");
const removeSectionGates = require("./removeSectionGates");
const saveCtaAfterSubmissionFormData = require("../ctaAfterSubmission/saveCtaAfterSubmissionFormData");

/**
 * @param form {HTMLFormElement}
 * @return {void}
 */
module.exports = async function submitWhitepaper2024Form(form) {
    const valid = triggerHtml5FormValidation(form);

    if (!valid) {
        return;
    }

    disableSubmitButtonInForm(form);

    openWhitepaper2024FormLoading();

    const formData = getFormDataAsWhitepaper2024FormData(form);

    const googleSheetsFormData = convertWhitepaper2024FormDataToGoogleSheetsFormData(formData, "SUBMISSION_SUBMIT_BUTTON_CLICK");

    try {
        void submitFormToGoogleSheets(googleSheetsFormData);
    } catch (e) {
        // failsafe
    }

    try {
        void sendWhitepaper2024FormSubmissionStartedEmailToFormsAtIterableCom(formData);
    } catch (e) {
        // failsafe
    }

    identifyInHeap(formData['Email']);

    saveReturningUserData(formData);

    if (!shouldBlockEmailDomainSilently(formData['Email'])) {
        try {
            await submitFormToMarketo(formData);

            saveCtaAfterSubmissionFormData(formData);

            openSuccess();

            removeSectionGates();
        } catch (e) {
            const googleSheetsFormData = convertWhitepaper2024FormDataToGoogleSheetsFormData(formData, "SUBMISSION_VALIDATION_ERROR");
            void submitFormToGoogleSheets(googleSheetsFormData);
        }
    }
}
